import { BaseMdl } from './BaseMdl';
import { cast, Castable } from '@bitr/castable';

export class machineMdl {
    machine_id: number = 0;
    control_number: string = '';
    machine_name: string = '';
    site_name: string = '';
    office_code: string = '';
    office_name: string = '';
    product_code: string = '';
    product_name: string = '';
    lot_number: string = '';
    router_ip: string = '';
    router_mac: string = '';
    stb_mac: string = '';
    latitude: string = '';
    longitude: string = '';
    address: string = '';
    battery_level: string = '';
    threshold_high: string = '';
    threshold_low: string = '';
    notification_interval: number = 0;
    lending_flg: number = 0;
    remark: string = '';
    upd_date: string = '';
    acquisition_time: string = '';

    constructor(init?: Partial<machineMdl>) {
        Object.assign(this, init);
    }

    public static toJsonDataOnModel(data: any): any {
        return BaseMdl.toJsonOnModel(new machineMdl(), data);
    }
}

export class machinelistMdl {
    machine_id: number = 0;
    control_number: string = '';
    machine_name: string = '';
    site_name: string = '';
    office_code: string = '';
    office_name: string = '';
    product_code: string = '';
    product_name: string = '';
    lot_number: string = '';
    router_ip: string = '';
    router_mac: string = '';
    stb_mac: string = '';
    latitude: string = '';
    longitude: string = '';
    address: string = '';
    battery_level: string = '';
    threshold_high: string = '';
    threshold_low: string = '';
    notification_interval: number = 0;
    lending_flg: number = 0;
    moving_flg: number = 0;
    remark: string = '';
    upd_date: string = '';
    acquisition_time: string = '';
    corp_name: string = '';
    signalstrength: number = 0;

    constructor(init?: Partial<machinelistMdl>) {
        Object.assign(this, init);
    }

    public static toJsonDataOnModel(data: any): any {
        return BaseMdl.toJsonOnModel(new machinelistMdl(), data);
    }
}

export class machinelistCastMdl extends Castable {
    @cast machine_id: number;
    @cast control_number: string;
    @cast machine_name: string;
    @cast site_name: string;
    @cast office_code: string;
    @cast office_name: string;
    @cast product_code: string;
    @cast product_name: string;
    @cast lot_number: string;
    @cast router_ip: string;
    @cast router_mac: string;
    @cast stb_mac: string;
    @cast latitude: string;
    @cast longitude: string;
    @cast address: string;
    @cast battery_level: string;
    @cast threshold_high: string;
    @cast threshold_low: string;
    @cast notification_interval: number;
    @cast lending_flg: number;
    @cast moving_flg: number;
    remark: string;
    upd_date: string;
    acquisition_time: string;
    @cast corp_name: string;
    @cast signalstrength: number;
}
